import React, { useState } from "react"
import { Box, InputAdornment, TextField } from "@mui/material"
import { FxLabel } from "../label/FxLabel"
import { FxInputProps } from "./FxInput.props"
import { FxValidation } from "../validation/FxValidation"
import { FxIcon } from "../icon/FxIcon"

/**
 *
 * @param label
 * @param name
 * @param value
 * @param onValueChange
 * @param variant
 * @param size
 * @param className
 * @param info
 * @param disabled
 * @param placeholder
 * @param fullWidth
 * @param validations
 * @param validationResult
 * @param style
 * @param customErrors
 * @param endIcon
 * @param startIcon
 * @param labelAlignment
 * @constructor
 */
export const FxInput = ({
  label,
  name,
  value,
  path,
  onValueChange,
  variant = "outlined",
  size = "small",
  className,
  info,
  disabled,
  placeholder,
  fullWidth = false,
  validations,
  validationResult,
  style,
  customErrors,
  endIcon,
  endIconClick,
  startIcon,
  type,
  labelAlignment = 'top',
  textBoxLabel,
  sx = {},
  onEnter
}: FxInputProps) => {
  const [onBlur, setOnBlur] = useState(false)
  let inputProps = {};
  const endAdornmentClick = () => {
    if (endIconClick) {
      endIconClick();
    }
  }

  if (endIcon) {
    inputProps = {
      endAdornment: (
        <InputAdornment position="end" onClick={endAdornmentClick}>
          <FxIcon icon={endIcon} className="pointer" />
        </InputAdornment>
      ),
    };
  }
  if (startIcon) {
    inputProps = {
      startAdornment: (
        <InputAdornment position="start">
          <FxIcon icon={startIcon} />
        </InputAdornment>
      ),
    };
  }
  // if(type == 'number'){
  //   inputProps['inputMode'] = 'numeric';
  //   // inputProps['pattern'] = '[0-9]*'
  // }
  /**
   *
   * @param event
   */
  const onChange = (event: any) => {
    const data = { name, value: event.target.value, path }
    if (onValueChange) onValueChange(data)
  }

  const isMandatory = () => {
    if (validations && validations.length > 0) {
      return validations.includes('required')
    }
  };

  const showTextBoxLbl = () => {
    if (isMandatory() && textBoxLabel) {
      return <>
        {textBoxLabel} <span className="text-danger">*</span>
      </>
    } else if (textBoxLabel) {
      return <>{textBoxLabel}</>
    }
  }

  textBoxLabel = showTextBoxLbl()

  const keyPress=(e:any )=>{
    if (e.key === 'Enter') {
       console.log('value', e.target.value);
       const data = { name, value: e.target.value, path }
       if (onEnter) onEnter(data);
    }
  }
  return (
    <>
      <div className={`fx-input ${labelAlignment == 'top' ? 'alignmentTop' : 'alignmentLeft'}`}>
        {label && <div><FxLabel info={info} label={label} validations={validations} /></div>}
        <TextField
          className={className}
          type={type ? type : 'text'}
          label={textBoxLabel}
          size={size}
          name={name}
          value={value}
          onChange={onChange}
          variant={variant === "outlined" ? "outlined" : "standard"}
          disabled={disabled}
          fullWidth={fullWidth}
          placeholder={placeholder}
          style={style}
          onFocus={() => setOnBlur(false)}
          onBlur={() => setOnBlur(true)}
          InputProps={inputProps}
          sx={sx}
          onKeyDown={keyPress}
        />
      </div>
      <FxValidation name={name}
        value={value}
        validations={validations}
        validationResult={validationResult}
        onBlur={onBlur}
        customErrors={customErrors} />
    </>
  )
}
